function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z"
});

const SvgChartBar = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "white",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChartBar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chart-bar.87244aea.svg";
export { ForwardRef as ReactComponent };